import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import "react-dropdown-tree-select/dist/styles.css";

class CreateSopBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      errors: { name: "" },
    };
  }

  componentDidMount() {}

  onChangeInput = (e) => {
    e.preventDefault();
    this.setState({ errors: { name: "" } });
    this.setState({ [e.target.name]: e.target.value });
  };

  submit = (e) => {
    this.create();
  };

  create = () => {
    if (!this.state.name) {
      this.setState({ errors: { name: "Type Required" } });
      return;
    }
    var data = {
      sop_type_name: this.state.name,
      groupId: this.props.userDetails?.user?.group?.uuid,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/SOP/SOPInsert`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            swal("Success", response.data.message, "success");
            _this.props.closeEvent();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.create();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.", "info");
      });
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        {/* <div className="xp-contentbar"> */}
        <div className="row pt-3">
          <div className="col-lg-12">
            {/* <div className="card-header bg-primary">
                                <h5 className="card-title text-white">Create Workflow Type</h5>
                            </div> */}
            <div className="form-row">
              <div className="form-group col-md-12">
                <label for="exampleInputEmail1">
                  Workflow Type <sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  onChange={this.onChangeInput}
                  name="name"
                  className="form-control"
                  placeholder="Enter Workflow Type"
                />
                {!!errors.name && <span className="text-danger">{errors.name}</span>}
              </div>
            </div>

            <button onClick={this.submit} className="btn btn-primary my-3">
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default CreateSopBank;
